import '../css/BrowserTopBarMock.css';
import TapMarker from './TapMarker';

/**
 * Picture of the top of Facebook's / Messenger's in-app browser on iOS —
 * ✕ on the left, the padlock and site address with the app's name under it
 * in the middle, ••• on the right — with a tap marker on the •••.
 *
 * Drawn in markup rather than shipped as a screenshot so it shows the
 * guest's real site address and app name, stays sharp at any size, and
 * follows the club's palette.
 *
 * @param {object} props
 * @param {string} props.appName - 'Facebook' or 'Messenger', shown under the address
 * @param {string} props.host - the site's host name, shown as the address
 * @returns {JSX.Element}
 */
function BrowserTopBarMock({ appName, host }) {
  return (
    <div className="btb-mock" aria-hidden="true">
      <div className="btb-bar">
        <span className="btb-close">✕</span>
        <span className="btb-title">
          <span className="btb-host">
            <svg className="btb-lock" viewBox="0 0 12 14" fill="currentColor">
              <rect x="1" y="6" width="10" height="8" rx="2" />
              <path d="M3.5 6V4.5a2.5 2.5 0 0 1 5 0V6" fill="none" stroke="currentColor" strokeWidth="1.6" />
            </svg>
            <span className="btb-host-text">{host}</span>
          </span>
          <span className="btb-app">{appName}</span>
        </span>
        <span className="btb-more">
          •••
          <TapMarker className="btb-marker" />
        </span>
      </div>
      <div className="btb-page">
        <span className="btb-line btb-line--wide" />
        <span className="btb-line" />
        <span className="btb-line btb-line--short" />
      </div>
    </div>
  );
}

export default BrowserTopBarMock;
